import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initializeAppData, initializeAppDataold } from "./store/data-action";
import "./styles/css/normalize.css";
import "./styles/css/webflow.css";
import "./styles/css/global_tabclix.css";
import MyRoutes from "./components/MyRoutes";
import { useTranslation } from "react-i18next";
import track from "react-tracking";
import { sortNoIdComponents } from "./helpers/sort-components";
import RenderedComponent from "./layout/RenderedComponent";
import Navbar from "./layout/Navbar";
import PageApp from "./layout/PageApp";
import ProfileBackground from "./components/background/ProfileBackground";


/**
 * Highest component in the hierarchy
 */
function App() {
  const currentPage = useSelector((state) => state.datareducer.currentPage);
  const allData = useSelector((state) => state.datareducer.AllData)
  const nav = useSelector(state => state.datareducer.navBar);
  const dispatch = useDispatch();
  const { t } = useTranslation();


  // added the thing

  let sortComponents = sortNoIdComponents(nav); 
  const component = sortComponents.map(orderedComponent => <RenderedComponent value={orderedComponent} />)
// const sortedComponents = sortNoIdComponents(nav);

  /**
   * React toolkit also accepts actions creators that return function.
   * If it sees that you dispatch an action which is actually a function,
   * it will execute that function for you
   *
   * @param {none}
   *
   */
 
  const profile = allData.find((object) => {
           if (object.type === "profile") {
             return object;
           }
        });

  useEffect(() => {
    // taking data from db
    dispatch(initializeAppData());
    // var userLang = navigator.language || navigator.userLanguage;
    // alert("The language is: " + userLang);

    // taking data from JSON file in backend
    // dispatch(initializeAppDataold());
  }, []);



  return (
    <>
      <MyRoutes />
      {!currentPage && profile ? <ProfileBackground data={profile} /> : ""}
      <main>
        {currentPage ? <PageApp /> : ""}
        <Navbar value={component} />
      </main>
    </>
  );
}


const TrackedApp = track(
  // app-level tracking data
  { app: "tabclix" },

  // top-level options
  {
    // custom dispatch to console.log in addition to pushing to dataLayer[]
    dispatch: (data) => {
      // console.log(data);
    },
  }
)(App);

export default TrackedApp;


// OLD JSON CALL METHOD
// calls method to set initial css load
// const callFile = (jsonFileName) => {
//   axios.get(`/api/get-css/${jsonFileName}`).then(res => {
//     $("html").removeAttr('style')
//     Object.keys(res.data).map(function (key, index) {

//       document.documentElement.style.setProperty(`${key}`, `${res.data[key]}`)
//       const color = getComputedStyle(document.documentElement).getPropertyValue(`${key}`)
//     });
//     console.log(res.data)
//   })
// }
